<div class="signature-pad" style="--aspect-ratio: 760/190" data-private>
  <canvas #signaturepad [attr.data-testid]="mode + '-canvas'"></canvas>
  <img
    class="signature-pad__background-image"
    src="../../../../../assets/images/signature-pad-line.png"
    alt=""
    />
  </div>
  @if (showErrorMessages && signatureValidity?.isTouchingEdge) {
    <p class="signature-pad__error">
      You went outside the lines, please only draw within the box.
    </p>
  }
  @if (showErrorMessages && signatureValidity && !signatureValidity.isComplex) {
    <p
      class="signature-pad__error"
      >
      It's too small! Try again, and use more of the available drawing area.
    </p>
  }
  <div class="signature-pad__buttons">
    <app-button
      class="signature-pad__buttons__button"
      type="tertiary"
      size="small"
      (buttonClick)="cancelForInstance()"
      [dataTestId]="'draw-' + mode + '-cancel'"
      >
      Cancel
    </app-button>
    <app-button
      class="signature-pad__buttons__button"
      type="secondary"
      size="small"
      (buttonClick)="clearCanvas()"
      [dataTestId]="'draw-' + mode + '-clear'"
      >
      Reset
    </app-button>
    <app-button
      class="signature-pad__buttons__button"
      type="primary"
      size="small"
      (buttonClick)="setSignature()"
      [dataTestId]="'draw-' + mode + '-save'"
      >
      Save
    </app-button>
  </div>
